<template>
  <div class="wrapper">
    <nuxt-error-boundary @error="() => {}">
      <Swiper
        :modules="[SwiperAutoplay, SwiperEffectCreative, SwiperPagination]"
        :slides-per-view="1"
        :loop="true"
        :pagination="{
          clickable: true,
          bulletActiveClass: '!bg-white',
          renderBullet: (_index, className) => {
            return (
              `<span class='` +
              className +
              ` !w-3 !h-3 !mb-[22px] !bg-gray-30 !opacity-100'></span>`
            )
          }
        }"
        :autoplay="{
          delay: 6000,
          disableOnInteraction: true
        }"
        :creative-effect="{
          prev: {
            shadow: false,
            translate: ['-20%', 0, -1]
          },
          next: {
            translate: ['100%', 0, 0]
          }
        }"
      >
        <SwiperSlide v-for="(slide, index) in slides" :key="index">
          <div class="relative">
            <NuxtImg
              v-if="slide.imageUrl"
              format="webp"
              alt="cover page"
              :src="slide.imageUrl"
              class="w-screen hidden md:block object-cover object-center"
              :style="{ width: `100%`, height: `${newDesktopHeight}px` }"
            />
            <NuxtImg
              v-if="slide.mobileImageUrl"
              format="webp"
              alt="cover page"
              :src="slide.mobileImageUrl"
              class="w-screen md:hidden object-cover object-center"
              :style="{ width: `100%`, height: `${newMobileHeight}px` }"
            />
            <video
              v-if="slide.videoUrl"
              preload="none"
              playsinline
              :style="{ width: `100%`, height: `${newDesktopHeight}px` }"
              class="w-screen hidden md:block object-cover object-center pointer-events-none touch-none"
              autoplay
              loop
              muted
            >
              <!-- poster="/images/videoframe_thumbnail_desktop.webp" -->
              <source :src="slide.videoUrl" type="video/mp4" />
            </video>
            <video
              v-if="slide.mobileVideoUrl"
              preload="none"
              playsinline
              :style="{ width: `100%`, height: `${newMobileHeight}px` }"
              class="w-screen md:hidden object-cover object-center pointer-events-none touch-none"
              autoplay
              loop
              muted
            >
              <!-- poster="/images/videoframe_thumbnail.webp" -->
              <source :src="slide.mobileVideoUrl" type="video/mp4" />
            </video>
            <div class="absolute w-full h-full top-0">
              <div class="flex justify-center items-end h-full pb-[83px]">
                <div class="grid grid-flow-col auto-cols-fr gap-x-4">
                  <Button
                    v-if="slide.primaryButtonEn"
                    intent="secondary"
                    icon="arrow-up-right"
                    hide-icon-on-mobile
                    @click="
                      () =>
                        slide.primaryButtonHref &&
                        router.push(localePath(slide.primaryButtonHref))
                    "
                    >{{
                      locale === 'en'
                        ? slide.primaryButtonEn
                        : slide.primaryButtonTh
                    }}</Button
                  >
                  <Button
                    v-if="slide.secondaryButtonEn"
                    icon="arrow-up-right"
                    hide-icon-on-mobile
                    @click="
                      () =>
                        slide.secondaryButtonHref &&
                        router.push(localePath(slide.secondaryButtonHref))
                    "
                    >{{
                      locale === 'en'
                        ? slide.secondaryButtonEn
                        : slide.secondaryButtonTh
                    }}</Button
                  >
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </nuxt-error-boundary>
  </div>
</template>
<script lang="ts" setup>
import { cmsRepository } from '~/repository/cmsRepository'

const { locale } = useI18n()
const { width } = useWindowSize()
const router = useRouter()
const localePath = useLocalePath()

const desktopHeight = 595
const desktopWidth = 1340
const newDesktopHeight = computed(
  () => (desktopHeight / desktopWidth) * width.value
)

const mobileHeight = 793
const mobileWidth = 500
const newMobileHeight = computed(
  () => (mobileHeight / mobileWidth) * width.value
)

const { $serverApi } = useNuxtApp()
const cmsRepo = cmsRepository($serverApi)

const { data: slides } = await useAsyncData(
  'getLandingPageCarousel',
  async () => {
    const response = await cmsRepo.getWidget('landing-page-carousel')
    if (response.data.data.items[0]) return response.data.data.items
    return null
  }
)

// const slides: {
//   imageUrl?: string
//   mobileImageUrl?: string
//   videoUrl?: string
//   mobileVideoUrl?: string
//   primaryButton?: string
//   primaryButtonUrl?: string
//   secondaryButton?: string
//   secondaryButtonUrl?: string
// }[] = [
//   {
//     videoUrl:
//       'https://media-qa.caseclub.in.th/Banner/VDO%205s%20new%20text.mp4',
//     mobileVideoUrl:
//       'https://media-qa.caseclub.in.th/Banner/5s-Video_375x594.mp4',
//     primaryButton: t('landing.btnLeftBannertop'),
//     primaryButtonUrl: '/products?sortBy=desc',
//     secondaryButton: t('landing.btnRightBannertop'),
//     secondaryButtonUrl: '/personalization'
//   }
//   // {
//   //   imageUrl: '/images/cover-page-juli-baker-01.jpg',
//   //   mobileImageUrl: '/images/cover-page-juli-baker-01-mobile.jpg',
//   //   primaryButton: t('landing.btnLeftBannertop'),
//   //   secondaryButton: t('landing.btnRightBannertop')
//   // }
// ]

definePageMeta({
  head: {
    link: [
      {
        rel: 'preload',
        href: '/images/videoframe_thumbnail_desktop.webp',
        as: 'image',
        fetchpriority: 'high'
      },
      {
        rel: 'preload',
        href: '/images/videoframe_thumbnail.webp',
        as: 'image',
        fetchpriority: 'high'
      }
    ]
  }
})
</script>

<style scoped>
.wrapper {
  min-height: calc(100vw / 0.63);

  @media screen and (min-width: 768px) {
    min-height: calc(100vw / 2.25);
  }
}
</style>
